export function getBasePublicValuation() {
  return {
    realEstateValuation: {
      address: "",
      sqM: null,
      rooms: null,
      typologyID: 0
    },
    contactDesired: null,
    privateValuation: true
  };
}